import { ArrowLeftIcon } from '@grupoboticario/flora-react-icons';

import { HeaderCheckout } from './HeaderCheckout.components.styles';

import type { HeaderChekoutButtonProps } from './HeaderCheckout.components.d';

const HeaderCheckoutButton = ({ children, onClick, size }: HeaderChekoutButtonProps) => (
  <HeaderCheckout.Button
    has="iconLeft"
    icon={<ArrowLeftIcon size={16} />}
    onClick={onClick}
    size={size}
    data-header-checkout-button
  >
    {children}
  </HeaderCheckout.Button>
);

export default HeaderCheckoutButton;
